import React, { useState, useEffect } from 'react';
import { withTranslation } from 'react-i18next';
import {FaCheckCircle, FaTasks, FaExclamationTriangle } from 'react-icons/fa'; // Example icons

import {
  Row,
  Col,
  Breadcrumb,
  BreadcrumbItem,
  Alert
} from 'reactstrap';

import { getUsersTasksDashboard } from '../../services/dashboards'; // Import the API call
import { useTranslation } from 'react-i18next';
import { getComplianceCalenderWithDate } from 'src/services/dashboardImplementor';
import ComplianceCalendar from './component/calender';
import { RiProgress2Line } from 'react-icons/ri';



function DashboardImplementor() {
  const { t } = useTranslation();
  const [dashboardData, setDashboardData] = useState<any>(null);
  const [complianceStatus, setComplianceStatus] = useState<any>([]);

  const [usersTasksDashboard, setUsersTasksDashboard] = useState<any>([]);


  const fetchDashboardData = async () => {
    try {
      const data = await getComplianceCalenderWithDate();
      //console.log(data)
      
      if (data?.success) {
        setDashboardData(data.data.statusCounts);
        setComplianceStatus([{
          'Compliance': data?.data?.compliance,
          'Partial': data?.data?.partially,
          'NotCompliant': data?.data?.non_compliance,
        }])
        
      } else {
        setDashboardData(null);
      }
      
    } catch (error) {
      console.error("Error fetching dashboard data:", error);
    }
  };


  const fetchUsersTasksDashboard = async () => {
    try {
      const data = await getUsersTasksDashboard();
      if (data.success) {
        setUsersTasksDashboard(data.data);
      }
      //console.log(data);
    } catch (error) {
      console.error("Error fetching users tasks dashboard:", error);
    }
  }

  useEffect(() => {
    fetchDashboardData();
    
    fetchUsersTasksDashboard();
  }, []);

 

  return (
    <div className="root dashboard">
      <Breadcrumb>
      <BreadcrumbItem className="px-1">{t('header.you_are_here')}</BreadcrumbItem>
      <span className="mx-2">/</span> 
        <BreadcrumbItem active className='text-danger' 
       >{t('Dashboard.Dashboard')}</BreadcrumbItem>
      </Breadcrumb>
      <h5 className="mb-lg">{t('Dashboard.Dashboard')}</h5>

      <Row style={{ backgroundColor: 'white' }} className="mb-3 m-1 p-2">
        <h5 className="fw-semi-bold text-gray-700 ">{t('Dashboard.Tasks')}</h5>
        
       


        <Col sm={12} md={4} className="rounded">
              <div className='card  h-100 p-3 '>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                  <div>
               
                <h6 className="fw-semi-bold">{t('Dashboard.Completed_Tasks')}</h6>
              <h2 className="mt-2">{dashboardData?.done}</h2>

              </div>
              <div className='bg-success p-2 rounded'>
              <FaCheckCircle size={20} className="text-white" />
              </div>
              </div>
              </div>
            </Col>

      

        <Col sm={12} md={4} className="rounded">
              <div className='card  h-100 p-3'>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                  <div>
                 
                <h6 className="fw-semi-bold">{t('Dashboard.Tasks_in_progress')}</h6>
              <h2 className="mt-2">{dashboardData?.inProgress}</h2>

              </div>
              <div className='bg-warning p-2 rounded'>

              <RiProgress2Line size={20} className="text-white" />
              </div>
              </div>
              </div>
            </Col>

    

        <Col sm={12} md={4} className="rounded">
              <div className='card  h-100 p-3'>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: "space-between" }}>
                  <div>
                  <h6 className="fw-semi-bold">{t('Dashboard.Overdue_tasks')}</h6>

                  <h2 className="mt-2">{dashboardData?.notStarted}</h2>
                  </div>

               
                <div className='bg-danger p-2 rounded'>
                    <FaExclamationTriangle size={20} className="text-white" />
                  </div>
                </div>
              
              </div>
            </Col>
      </Row>

      {/* calender######## */}
      <div className='p-4 bg-white pt-3'>
      <ComplianceCalendar />
    </div>

     
    </div>
  );
}

export default withTranslation()(DashboardImplementor);
